import React from 'react';
import AdminBaseLayoutContainer from "../../components/BaseLayout/AdminBaseLayoutContainer";
import ClubsListView from "./views/ClubsListView";


class ClubList extends React.Component {

  render() {
    return (
      <AdminBaseLayoutContainer>
        <ClubsListView />
      </AdminBaseLayoutContainer>
    )
  }

}


export default ClubList;
